import Vue from 'vue'
import Router from 'vue-router'
import MinChat from '@/components/mail/minChat'
import ListRoom from '@/components/mail/ListRoom'
import ListChat from '@/components/mail/ListChat'
import LayoutHeader from '@/components/mail/LayoutHeader'
import check_authen from '@/components/mail/check_authen'
import Addfriend from '@/components/mail/Addfriend'
import My_Profile from '@/components/mail/My_Profile'
import edit_displayname from '@/components/mail/Edit/edit_displayname'
import edit_status from '@/components/mail/Edit/edit_status'
import Creategroup from '@/components/mail/Creategroup'
// import LeftSideMobile from '@/components/LeftSideMobile'
// import LayoutChat from '@/components/LayoutChat'
// import EditProfile from '@/components/settings/EditProfile'
// import Policy from '@/components/settings/Policy'
// import Contact from '@/components/settings/Contact'
// import Feedback from '@/components/settings/Feedback'
// import SendFileOnebox from '@/components/settings/SendFileOnebox'
// import ManageFriend from '@/components/settings/ManageFriend'
// import CreateGroup from '@/components/manage/Creategroup'
// import AddFriend from '@/components/manage/Addfriend'
// import Forwardmessage from '@/components/manage/Forwardmessage'
// import ChatLayout from '@/components/ChatLayout'
// import Profilefriend from '@/components/Profilefriend'
// import Qrcodepage from '@/components/manage/Qrcodepage'
// import Wallpaper from '@/components/manage/Wallpaper'
// import login from '@/components/login'
// import loginnotmapemail from '@/components/login_notmapemail'
// import login_checkuser from '@/components/loginCheckuser'
// import register from '@/components/Register'
// import registernotmapmail from '@/components/Register_notmapmail'
// // tasks Mobile
// import homepage_all_project_mobile from '@/components/task/homepage_all_project_mo'
// import homepage_task_mobile from '@/components/task/homepage_task_mo'
// import homepage_project_mobile from '@/components/task/homepage_project_mo'
// import homepage_calendar_mobile from '@/components/task/homepage_calendar_mo'
// import create_project_mobile from '@/components/task/create_project_page_mo'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/minchat', component: MinChat },
    // { path: '/layout', component: LayoutHeader },
    // { path: '/list_room', component: ListRoom },
    // { path: '/chat_room', component: ListChat }
    { path: '/check_authen', component: check_authen},
    { path: '/',
      component: LayoutHeader,
      children: [
        { path: '/list_room', component: ListRoom},
        { path: '/chat_room', component: ListChat},
        { path: '/add_friend', component: Addfriend},
        { path: '/my_profile', component: My_Profile},
        { path: '/edit_displayname', component: edit_displayname},
        { path: '/edit_status', component: edit_status},
        { path: '/create_group', component: Creategroup}
      ]
    }
    // { path: '/minchat/:servicename/:key', component: MinChat },
    // { path: '/layout/:mail/:key', component: Layout },
    // { path: '/layout//:key', component: Layout },
    // { path: '/login/:mail', component: login },
    // { path: '/notmap', component: loginnotmapemail },
    // { path: '/login_service/:servicename/:key', component: login_checkuser },
    // { path: '/register/:mail', component: register },
    // { path: '/registernotmapmail', component: registernotmapmail },
    // { path: '/layouts',
    //   component: LayoutChat,
    //   children: [
    //     { path: '/layouthompage', component: LeftSideMobile },
    //     { path: '/chat/room/:roomid', component: ChatLayout },
    //     { path: '/settings/profile', component: EditProfile },
    //     { path: '/settings/policy', component: Policy },
    //     { path: '/settings/support', component: Contact },
    //     { path: '/settings/feedback', component: Feedback },
    //     { path: '/settings/uploadfile/onebox', component: SendFileOnebox },
    //     { path: '/settings/managefriend', component: ManageFriend },
    //     { path: '/creategroup', component: CreateGroup },
    //     { path: '/addfriend', component: AddFriend },
    //     { path: '/mobile/qrcode', component: Qrcodepage },
    //     { path: '/mobile/wallpaper/:roomid', component: Wallpaper },
    //     { path: '/mobile/forward/:roomid', component: Forwardmessage },
    //     { path: '/mobile/profilefriend/:profileid', component: Profilefriend },
    //     { path: '/mobile/task/project', component: homepage_all_project_mobile },
    //     { path: '/mobile/task/:projectid/:roomid', component: homepage_task_mobile },
    //     { path: '/mobile/room/project/:roomid', component: homepage_project_mobile },
    //     { path: '/mobile/task/calendar', component: homepage_calendar_mobile },
    //     { path: '/mobile/task/createproject', component: create_project_mobile }
    //   ]
    // }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js